/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    markers: [],
    news: [],
    galleries: [],
    meldungen: [],
    downloads: [],
    geschichte: [],
    vorstand: [],
    verein: [],
    vereinMain: [],
    vereinLeft: [],
    vereinMiddle: [],
    kontakt: [],
    fetchcomplete: false,
    fetchNewsComplete: false,
    fetchGalleriesComplete: false,
    fetchMeldungenComplete: false,
    fetchDownloadsComplete: false,
    fetchGeschichteComplete: false,
    fetchVereinComplete: false,
    fetchVorstandComplete: false,
    currentMarker: 'bahnhof',
    currentHeight: '400px',
    present: true,
    opengallery: 0,
  },
  mutations: {

    opengallery (state, id){

      var result = state.galleries.filter(obj => {
        return obj.id == id;
      })

      state.opengallery = result[0];

      // console.log(state.opengallery.titel);

    },

    closegallery(state){

      state.opengallery = 0;

    },

    setmarkers(state, response){

      var i
      for (i = 0; i < response.data.length; i++){

        state.markers[i] = response.data[i].acf;

        // console.log(state.markers);

      }

      state.fetchcomplete = true;

    },

    setnews(state, response){

      var i
      for (i = 0; i < response.data.length; i++){

        state.news[i] = response.data[i].acf;

        // console.log(state.news);

      }

      state.fetchNewsComplete = true;

    },

    setgalleries(state, response){

      var i
      for (i = 0; i < response.data.length; i++){

        state.galleries[i] = response.data[i].acf;

        state.galleries[i].id = response.data[i].id;

      }

      // console.log(state.galleries);

      state.fetchGalleriesComplete = true;

    },

    setmeldungen(state, response){

      var i
      for (i = 0; i < response.data.length; i++){

        state.meldungen[i] = response.data[i].acf;

        // console.log(state.meldungen);

      }

      state.fetchMeldungenComplete = true;

    },

    setgeschichte(state, response){

      var i
      for (i = 0; i < response.data.length; i++){

        state.geschichte[i] = response.data[i].acf;

        // console.log(state.meldungen);

      }

      state.fetchGeschichteComplete = true;

    },

    setdownloads(state, response){

      var i
      for (i = 0; i < response.data.length; i++){

        state.downloads[i] = response.data[i].acf;

      }

      state.fetchDownloadsComplete = true;

    },

    setvorstand(state, response){

      var i
      for (i = 0; i < response.data.length; i++){

        state.vorstand[i] = response.data[i].acf;

      }

      console.log(state.vorstand);

      state.fetchVorstandComplete = true;

    },

    setverein(state, response){

      var i
      for (i = 0; i < response.data.length; i++){

        state.verein[i] = response.data[i].acf;

      }

      // extract the main verein from all verein and save in store
      var result = state.verein.filter(obj => {
        return obj.id == 1;
      })

      state.vereinMain = result[0];

      // extract the bottom left box from all verein and save in store
      var result = state.verein.filter(obj => {
        return obj.id == 2;
      })

      state.vereinLeft = result[0];

      // extract the bottom middle box from all verein and save in store
      var result = state.verein.filter(obj => {
        return obj.id == 3;
      })

      state.vereinMiddle = result[0];

      // extract the bottom middle box from all verein and save in store
      var result = state.verein.filter(obj => {
        return obj.id == 4;
      })

      state.kontakt = result[0];

      // extract the bottom middle box from all verein and save in store
      var result = state.verein.filter(obj => {
        return obj.id == 5;
      })

      state.vereinMitglied = result[0];

      state.fetchVereinComplete = true;

    },











    updatecurrent(state, response){

      state.currentMarker = response;
      console.log(state.currentMarker);

    },

    updateheight(state, response){

      state.currentHeight = response + 'px';
      console.log(state.currentHeight);

    },

    updatetime(state){

      state.present = !state.present;
      console.log(state.present);

    }


  },
  actions: {

    initialfetch (context){

      // fetch marker positions
      axios.get("https://weissenburgbad.ch/php/markers.json")

      .then(response => {

        context.commit('setmarkers', response);

      });


      // fetch news
      axios.get("https://weissenburgbad.ch/php/news.json")

      .then(response => {

        context.commit('setnews', response);

      });

      // fetch galleries
      axios.get("https://weissenburgbad.ch/php/fotos.json")

      .then(response => {

        // console.log(response.data);

        context.commit('setgalleries', response);

      });


      // fetch meldungen
      axios.get("https://weissenburgbad.ch/php/meldungen.json")

      .then(response => {

        context.commit('setmeldungen', response);

      });

      // fetch downloads
      axios.get("https://weissenburgbad.ch/php/downloads.json")

      .then(response => {

        context.commit('setdownloads', response);

      });

      // fetch verein
      axios.get("https://weissenburgbad.ch/php/verein.json")

      .then(response => {

        context.commit('setverein', response);

      });

      // fetch vorstand
      axios.get("https://weissenburgbad.ch/php/vorstand.json")

      .then(response => {

        context.commit('setvorstand', response);

      });

      // fetch news
      axios.get("https://weissenburgbad.ch/php/geschichte.json")

      .then(response => {

        context.commit('setgeschichte', response);

      });


      // update the json API for the next user :)
      axios.get("https://weissenburgbad.ch/php/control.php")

      .then(response => {

        console.log("Job Done");

      });

      // context.commit('setprojekt', response.data[0].acf);

    }


  },
  modules: {
  }
})
